import { CHARACTERS, isCharacterUnlocked, type CharacterDef } from "../../engine/characterDefs";
import { Player } from "../../engine/player";
import { Strings } from "../../engine/strings";
import { WeaponVisual } from "../../engine/weaponVisual";
import { XY } from "../../engine/xy";
import { getPickupIconFilenameByKey } from "../pickupIconMap";
import type { PlayerVisualState } from "../playerVisualState";

export interface CharacterCardData {
	id: string;
	name: string;
	description: string;
	spriteState: PlayerVisualState;
	locked: boolean;
	unlockHint: string | null;
	loadoutIconFilenames: string[];
}

export function buildCharacterCards(maxLevelReached: number): CharacterCardData[] {
	return CHARACTERS.map((def) => buildCard(def, maxLevelReached));
}

function buildCard(def: CharacterDef, maxLevelReached: number): CharacterCardData {
	const locked = !isCharacterUnlocked(def, maxLevelReached);
	return {
		id: def.id,
		name: Strings.get(def.nameKey) ?? def.id,
		description: Strings.get(def.descriptionKey) ?? def.descriptionKey,
		spriteState: {
			characterId: def.id,
			bodyState: "idle",
			weaponVisual: starterWeaponVisual(def),
		},
		locked,
		unlockHint: locked && def.unlockHintKey !== null ? (Strings.get(def.unlockHintKey) ?? def.unlockHintKey) : null,
		loadoutIconFilenames: def.loadoutIconKeys
			.map((key) => getPickupIconFilenameByKey(key))
			.filter((filename): filename is string => filename !== null),
	};
}

// The starter weapon only exists inside applyLoadout, so a throwaway off-board
// Player is the single source of truth for what each character holds.
function starterWeaponVisual(def: CharacterDef): WeaponVisual {
	const player = new Player(new XY(0, 0));
	def.applyLoadout(player);
	return player.getSelectedWeapon()?.getWeaponVisual() ?? WeaponVisual.NONE;
}
